
import "es6-promise";

import Vue, { ComponentOptions } from "vue";
import { palette, getStatusColor, themeColors } from "../palette";

import Component from "vue-class-component";
import {
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Watch
} from "vue-property-decorator";

import { ComputeJob } from "../model";
import ExpiryDialog from "./Dialogs/ExpiryDialog.vue";

@Component({
  components: { ExpiryDialog },
  filters: {}
})
export default class JobStatusCard extends Vue {
  @Prop({ type: Object })
  public job: ComputeJob | null;

  @Prop({ default: true, type: Boolean })
  showCancelButton: boolean;

  @Prop({ default: true, type: Boolean })
  showRunAgainButton: boolean;

  @Prop({ default: () => [], type: Array })
  public extraTableRows: string[][] | null;

  getStatusColor = getStatusColor;
  themeColors = themeColors;

  // http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
  hashCode(s: string): number {
    var hash = 0;
    if (s.length == 0) return hash;
    for (let i = 0; i < s.length; i++) {
      let char = s.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
  }

  askCancelJob(id: string) {
    this.$emit("cancel-job-clicked", id);
  }

  cloneJob(id: string) {
    this.$emit("clone-job-clicked", id);
  }

  openDialog(refName: string) {
    // console.log('Opened: ' + refName);
    ((this.$refs as any)[refName] as any).open();
  }

  closeDialog(refName: string) {
    // console.log('Closed: ' + refName);
    ((this.$refs as any)[refName] as any).close();
  }
}
